import useCsrfCookieFetch from '../hooks/useCsrfCookieFetch';

export const useCsrfCookie = () => useState(
  'csrf-cookie',
  () => useCsrfCookieFetch(),
);
